import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import { updateAIAuditLogPluginState } from '../../../../pm-plugins/ai-audit-logs/commands';
import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';
import { useAnalyticsFlowEventsQueue } from '../../../utils/analytics/analyticsFlowUtils';
import { ErrorMessage, getStepName, retryEnabled } from '../../../utils/error-handling';
import { FAILURE_REASON } from '../../../utils/errors';
export function ErrorScreenWithLogic(_ref) {
  var _errorInfo$failureRea;
  var errorInfo = _ref.errorInfo;
  var aiExperienceCommonData = useAIExperienceCommonDataContext();
  var endExperience = aiExperienceCommonData.endExperience,
    sendToAIExperienceMachine = aiExperienceCommonData.sendToAIExperienceMachine,
    editorView = aiExperienceCommonData.editorView;
  useAnalyticsFlowEventsQueue({
    stepName: getStepName(errorInfo),
    attributes: _objectSpread({
      errorType: (_errorInfo$failureRea = errorInfo.failureReason) !== null && _errorInfo$failureRea !== void 0 ? _errorInfo$failureRea : FAILURE_REASON.UNKNOWN,
      sawAupViolation: errorInfo.failureReason === FAILURE_REASON.AUP_VIOLATION
    }, errorInfo)
  });
  React.useEffect(function () {
    if (fg('platform_editor_ai_audit_logs_events')) {
      if (errorInfo.failureReason === FAILURE_REASON.AUP_VIOLATION) {
        var command = updateAIAuditLogPluginState({
          'aup-violation': {
            eventStatus: 'send-event'
          }
        });
        command(editorView.state, editorView.dispatch);
      }
    }
  }, [errorInfo.failureReason, editorView]);
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: ErrorMessage(errorInfo),
    onCancel: function onCancel() {
      return endExperience();
    },
    onRetry: function onRetry() {
      return sendToAIExperienceMachine({
        type: 'retry'
      });
    },
    showRetryButton: retryEnabled(errorInfo)
  });
}